import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Pagination from '@/components/Pagination/index.vue';
import Inr from '@/components/Inr/index.vue';
import { getBranches } from '@/api/locations/branches';
import { searchDealers } from '@/api/dealers';
import { getLedgersPaymentTypeWise, getLedgersPaymentTypeWiseExcel } from '@/api/ledgers'; // your API method
import { getQuery } from '@/utils';
import { BranchAgentService } from '@/services/branch-agent-service';
import moment from 'moment';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = false;
    this.downloadLoading = false;
    this.branchList = undefined;
    this.branchListLoading = false;
    this.dealerList = [];
    this.dealerListLoading = false;
    this.grandTotal = 0;
    this.dateRange = {
      start: '',
      end: ''
    };
    this.listQuery = {
      page: 1,
      limit: 10,
      branchId: undefined,
      dealerId: undefined,
      paymentType: undefined,
      startDate: undefined,
      endDate: undefined
    };
    this.paymentMethods = [{
      label: 'Payment',
      key: 'Payment'
    }, {
      label: 'Credit Note',
      key: 'Credit Note'
    }, {
      label: 'Credit Note-Item Wise',
      key: 'Credit Note-Item Wise'
    }, {
      label: 'Debit Note',
      key: 'Debit Note'
    }, {
      label: 'Debit Note-Item Wise',
      key: 'Debit Note-Item Wise'
    }, {
      label: 'Sales Inwards',
      key: 'Sales Inwards'
    }, {
      label: 'Credit Note Inward',
      key: 'Credit Note Inward'
    }];
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        if (currentDate.month() <= 2) startYear--;
        return {
          start: moment([startYear, 3, 1]),
          end: moment([startYear + 1, 3, 1]).subtract(1, 'days')
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        if (currentDate.month() <= 2) startYear--;
        return {
          start: moment([startYear - 1, 3, 1]),
          end: moment([startYear, 3, 1]).subtract(1, 'days')
        };
      }
    }];
    this.assignedBranches = null;
  }
  async activated() {
    this.assignedBranches = await BranchAgentService.assignBranchId();
    if (this.assignedBranches === null) {
      throw new Error('You are not assigned to a branch.');
    }
    this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
    this.dateRange = {
      start: this.$moment().startOf('month').format('YYYY-MM-DD 00:00') + ' am',
      end: this.$moment().endOf('day').format('YYYY-MM-DD 11:59') + ' pm'
    };
    await this.getList();
  }
  async getList() {
    try {
      var _this$dateRange, _this$dateRange2, _data$grandTotal;
      this.listLoading = true;
      const params = {
        ...this.listQuery
      };
      if ((_this$dateRange = this.dateRange) !== null && _this$dateRange !== void 0 && _this$dateRange.start && (_this$dateRange2 = this.dateRange) !== null && _this$dateRange2 !== void 0 && _this$dateRange2.end) {
        params.startDate = this.dateRange.start;
        params.endDate = this.dateRange.end;
      }
      const data = await getLedgersPaymentTypeWise(params);
      this.list = data.data;
      this.total = data.total;
      this.grandTotal = (_data$grandTotal = data.grandTotal) !== null && _data$grandTotal !== void 0 ? _data$grandTotal : 0;
    } catch (error) {
      console.error(error);
    } finally {
      this.listLoading = false;
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  async fetchBranches() {
    this.branchListLoading = true;
    this.branchList = await getBranches(getQuery({
      enabled: true,
      sort: 'name,ASC'
    }));
    this.branchListLoading = false;
  }
  async getDealerList(query = null) {
    var _this$listQuery$branc;
    if (!query || query.length < 2) {
      this.dealerList = [];
      return;
    }
    const isNumeric = /^[0-9]+$/.test(query);
    this.dealerList = await searchDealers({
      keyword: query,
      searchBy: isNumeric ? 'dealerId' : 'name',
      applyBranchIdFilter: true,
      branchId: (_this$listQuery$branc = this.listQuery.branchId) !== null && _this$listQuery$branc !== void 0 ? _this$listQuery$branc : null
    });
  }
  formatDate(timestamp) {
    if (!timestamp) return '';
    return new Date(timestamp).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC'
    });
  }
  getPaymentTypeTag(type) {
    var _map$type;
    const map = {
      Payment: 'success',
      'Credit Note': 'warning',
      'Credit Note-Item Wise': 'warning',
      'Debit Note': 'danger',
      Purchase: 'info'
    };
    return (_map$type = map[type]) !== null && _map$type !== void 0 ? _map$type : '';
  }
  getSummary(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = 'Total';
        return;
      }
      if (column.property === 'amount') {
        const pageTotal = data.reduce((acc, row) => acc + parseFloat(row.amount || 0), 0);
        sums[index] = `₹ ${Math.round(pageTotal).toLocaleString('en-IN')} / ₹ ${Math.round(this.grandTotal).toLocaleString('en-IN')}`;
      } else {
        sums[index] = '';
      }
    });
    return sums;
  }
  async exportToExcel() {
    try {
      var _this$dateRange3, _this$dateRange4;
      this.downloadLoading = true;
      const params = {
        ...this.listQuery
      };
      if ((_this$dateRange3 = this.dateRange) !== null && _this$dateRange3 !== void 0 && _this$dateRange3.start && (_this$dateRange4 = this.dateRange) !== null && _this$dateRange4 !== void 0 && _this$dateRange4.end) {
        params.startDate = this.dateRange.start;
        params.endDate = this.dateRange.end;
      }
      // Calls the GET endpoint which returns an ArrayBuffer
      const response = await getLedgersPaymentTypeWiseExcel(params);
      const blob = new Blob([response], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'ledgers_payment_type_wise.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      this.$message({
        message: 'Failed to export Excel',
        type: 'error'
      });
    } finally {
      this.downloadLoading = false;
    }
  }
};
default_1 = __decorate([Component({
  name: 'LedgersPaymentTypeWise',
  components: {
    Pagination,
    Inr
  }
})], default_1);
export default default_1;